import React, { useState, useRef } from 'react';

const IconCandyMenu = ({
    handleClick,
    isHighlighted,
    animationDuration = 300
}) => {
    const svgRef = useRef(null);
    const animationInterval = animationDuration / 9;
    const [intervalId, setIntervalId] = useState('');

    const animateCircles = (isActive) => {
        let currentCircle = isActive ? 8 : 0;
        const stepVal = isActive ? -1 : 1;
        const circleFill = isActive ? '#535353' : '#FD9A00';

        clearInterval(intervalId); // Make sure we aren't going to miss any circles when we animate forward/backward
        const newInterval = setInterval(() => {
            svgRef.current?.children[currentCircle].setAttribute(
                'fill',
                circleFill
            );
            currentCircle += stepVal;
            if (
                (currentCircle < 0 && isActive) ||
                (currentCircle > 8 && !isActive)
            )
                clearInterval(newInterval); // At the point of creation our intervalId isn't set yet, so refer to the original declaration
        }, animationInterval);

        setIntervalId(newInterval);
    };

    const handleIconClick = () => {
        handleClick();
    };

    const handleMouseEnter = () => {
        animateCircles(false);
    };

    const handleMouseLeave = () => {
        animateCircles(true);
    };

    return (
        <svg
            id='candy-menu'
            ref={svgRef}
            onClick={handleIconClick}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            width={34}
            height={34}
            style={{ cursor: 'pointer' }}
        >
            <circle r={4.34} cy={4.34} cx={4.34} fill='#535353' />
            <circle r={4.34} cy={4.34} cx={16.3} fill='#535353' />
            <circle r={4.34} cy={16.3} cx={4.34} fill='#535353' />

            <circle r={4.34} cy={4.34} cx={28.3} fill='#535353' />
            <circle r={4.34} cy={16.3} cx={16.3} fill='#535353' />
            <circle r={4.34} cy={28.3} cx={4.34} fill='#535353' />

            <circle r={4.34} cy={16.3} cx={28.3} fill='#535353' />
            <circle r={4.34} cy={28.3} cx={16.3} fill='#535353' />
            <circle r={4.34} cy={28.3} cx={28.3} fill='#535353' />
        </svg>
    );
};

export default IconCandyMenu;
